import { get } from 'lodash';
import { message } from 'antd';

const ERROR_MESSAGE = {
  ResourceExisted: '资源已经存在',
  InvalidAnimationResource: '无效的动画文件',
};

interface UploadEffectParam {
  file: File;
  sessionId: string;
  type: 'VIDEO' | 'DOC' | 'AUDIO' | 'IMG' | 'ANIMATION';
  updateProgress: (progress: number) => void;
  subject: 'chinese' | 'english' | string;
}

export function uploadHelper(
  param: UploadEffectParam,
  onSuccess: (res: any) => void,
  onError: (code: string) => void
) {
  const { token, aospSubUserId, schoolId } = alo7Account;
  const baseinfo = [schoolId || 0, aospSubUserId].join();
  const headers = { baseinfo, authorization: `Bearer ${token}` };

  const formData = new FormData();
  formData.append('file', param.file);
  formData.append('type', param.type);
  formData.append('sessionId', param.sessionId);

  const xhr = new XMLHttpRequest();
  xhr.upload.onprogress = function(event: ProgressEvent) {
    param.updateProgress(Math.floor((event.loaded / event.total) * 100));
  };

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
        onSuccess(JSON.parse(xhr.responseText));
      } else {
        const res = nx.parse(xhr.responseText);
        const code = get(res, 'errors[0].code');
        if (code === 'session.expired') {
          // localStorage.removeItem('alo7-account');
          if (alo7Nav.env === 'inner') {
            location.reload();
          } else {
            alo7Nav.eventemitter.emit('session.expired');
          }
        } else {
          if (xhr.status !== 0) {
            message.error('上传失败, ' + ERROR_MESSAGE[code] || '未知原因');
          }
        }
        onError(code);
      }
    }
  };

  xhr.open('post', alo7Api.prefix.host + `/api/v1/resources_${param.subject}`, true);

  nx.forIn(headers, (key, value) => xhr.setRequestHeader(key, value));
  xhr.send(formData);

  return xhr;
}
